import React from "react";
import SEO from '../../Components/SEO';
import styled from 'styled-components';
import illustration1 from '../../assets/illustration/illustration1.png';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { ThemeContext } from '../../utils/context';
import colors from '../../utils/style/colors';

// ===== UTILS =============
// AnimatedGroup is used inside ServiceCard
import ServiceCard from '../../Components/ServiceCard';

// Langage
import "../../i18n";
import { useTranslation } from 'react-i18next';
import useCart from '../Boutique/hooks/useCart';
import CartDrawer from '../Boutique/component/CartDrawer';
import CartButton from '../Boutique/component/CartButton';

// =========== ICONES ================ (replaced by Iconify Solar icons)

// Icons 
import { Icon } from "@iconify/react";

// Converted to Tailwind in JSX

const ButtonDevis = styled(Link)`
  position: relative;
  padding: 10px 20px;
  border-radius: 25px;
  


  color: #ffffff;
    background: #008cff;
    border: 1px solid #fff;
    /* text-shadow: 0 0 5px #ffffff, 0 0 10px #ffffff, 0 0 20px #ffffff; */
    box-shadow: 0 0 5px #008cff, 0 0 20px #008cff, 0 0 50px #008cff,
      0 0 100px #008cff;


  margin-top: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  ion-icon {
    font-size: 24px;
    transform: translateX(10px);
    color: ${props => (props.theme === 'light' ? '#434343' : '#d0d0d0')};
    animation: moove 2s infinite both;
    @keyframes moove {
      0% {
        transform: translateX(10px);
      }
      50% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(10px);
      }
    }
  }
  &:hover {
  
    box-shadow: 0 0 5px #54b2ff, 0 0 30px #4fb0ff, 0 0 70px #5cb6ff,
    0 0 100px #008cff;
  color: ${props => (props.theme === 'light' ? '#434343' : '#d0d0d0')};
  border: 1px solid #fff;
  background: transparent;

    ion-icon {
      color: #ffffff;
      animation: none;
    }
  }
  @media screen and (max-width: 768px) {
    /* padding: 10px 25px; */
  }
`;

// ================== About & Services now use Tailwind directly in JSX ==================

function Home() {
  const { theme } = useContext(ThemeContext);

  const { t } = useTranslation();
  const [cartOpen, setCartOpen] = React.useState(false);
  const { cart, cartCount, removeFromCart, updateQty } = useCart();

  return (
    <div>
      <SEO
        title='Accueil'
        description={'Startup studio: création de sites, SEO et marketing digital.'}
        canonical={'https://safaridew.vercel.app/'}
      />
      <div
        className={`relative mx-auto flex flex-col items-center justify-center h-screen p-5 transition-colors duration-300 bg-gradient-to-tr ${theme === 'light' ? 'from-[#c2c2c2] to-transparent' : 'from-[#565656] to-transparent'
          }`}
        style={{
          clipPath:
            'polygon(30% 0%, 70% 0%, 100% 0%, 100% 85%, 71.3% 90.5%, 30% 100%, 0% 87.5%, 0% 0%)',
        }}
      >
        {/* Grand titre  */}
        <h3
          className={`text-center transition-colors duration-300 text-3xl sm:text-5xl font-semibold ${theme === 'light' ? 'text-[#434343]' : 'text-[#e2e2e2]'
            } `}
        >
          {t("imagination")} <br />

          {t("take_care")}
        </h3>

        {/* Illustration */}
        <img
          src={illustration1}
          alt="illustration"
          className="w-full h-[72vh] object-cover fixed right-[-20%] bottom-[5%] -z-10 md:w-4/5 md:h-[80vh] sm:w-full sm:h-[70vh]"
        />
        <ButtonDevis to="/Devis" theme={theme} className='hover:scale-110'>
          {' '}
          <span> {t("apply")} </span>{' '}
          <ion-icon name="arrow-forward-circle-outline"></ion-icon>{' '}
        </ButtonDevis>
      </div>

      <div className="p-2.5">
        <div className="text-center mt-20">
          <h2>
            {t("we_are")}
          </h2>
          <p>
            {t("we_work")}
          </p>
        </div>

        <div className='grid grid-cols-2 md:grid-cols-3 gap-10 my-6 mx-2 md:mx-4'>
          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("app_create")} </h3>
            <Icon icon="solar:code-square-bold-duotone" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("design")} </h3>
            <Icon icon="solar:figma-file-bold-duotone" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("marketing")} </h3>
            <Icon icon="solar:chat-square-like-bold" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("campaigns")} </h3>
            <Icon icon="solar:target-bold-duotone" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("community")} </h3>
            <Icon icon="solar:users-group-two-rounded-bold-duotone" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("ia")} </h3>
            <Icon icon="solar:cpu-bolt-bold-duotone" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("graphic")} </h3>
            <Icon icon="solar:pen-new-square-bold-duotone" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("lead")} </h3>
            <Icon icon="solar:diploma-verified-bold" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>

          <ServiceCard>
            <h3 className='text-slate-400 text-xs md:text-lg text-center'> {t("admin")} </h3>
            <Icon icon="solar:window-frame-bold-duotone" className='text-7xl md:text-8xl' style={{ color: theme === 'light' ? undefined : colors.secondary }} />
          </ServiceCard>
        </div>
      </div>

      <CartDrawer
        isOpen={cartOpen}
        onClose={() => setCartOpen(false)}
        cart={cart}
        onRemove={removeFromCart}
        onUpdateQty={updateQty}
      />

      <CartButton cartCount={cartCount} onCartOpen={() => setCartOpen(true)} />
    </div>
  );
}

export default Home;
